import { ca } from '@cian/analytics';

/**
 * @description Событие: пользователь развернул или свернул таблицу ипотечных предложений.
 */
export function trackMortgageOffersTableExpandToggle(expanded: boolean): void {
  ca('eventSite', {
    action: 'click_mortgage_offers_table_expand',
    category: 'Promo',
    label: expanded ? 'expand' : 'collapse',
    name: 'oldevent',
    useLastProducts: true,
  });
}
